import LandingBanner from './component'
export default LandingBanner
